<template>
  <div class="login-page">
    <div class="login-page__backdrop" :style="backdropStyle">
      <div class="login-page__overlay"></div>
      <div class="login-page__glow login-page__glow--left"></div>
      <div class="login-page__glow login-page__glow--right"></div>
    </div>

    <div class="login-page__content">
      <section class="login-page__intro">
        <p class="login-page__eyebrow">SSY POINTS MALL</p>
        <h1>积分商城后台管理系统</h1>
        <p class="login-page__desc">
          统一管理商品、订单、积分、会员和小程序内容，帮助积分商城业务高效运营。
        </p>
      </section>

      <section class="login-panel">
        <div class="login-panel__header">
          <h2>欢迎登录</h2>
          <p>请输入账号和密码进入系统</p>
        </div>

        <el-form
          ref="loginForm"
          :model="form"
          :rules="rules"
          class="login-form"
          @keyup.enter.native="login"
        >
          <el-form-item prop="username">
            <el-input
              v-model.trim="form.username"
              prefix-icon="el-icon-user"
              placeholder="请输入用户名"
              size="medium"
            />
          </el-form-item>

          <el-form-item prop="password">
            <el-input
              v-model.trim="form.password"
              prefix-icon="el-icon-lock"
              placeholder="请输入密码"
              type="password"
              size="medium"
              show-password
            />
          </el-form-item>

          <el-button
            class="login-form__submit"
            type="primary"
            :loading="loading"
            @click="login"
          >
            登录
          </el-button>
        </el-form>
      </section>
    </div>
  </div>
</template>

<script>
import http from '../../utils/http'

export default {
  computed: {
    backdropStyle () {
      return {
        backgroundImage: `url(${process.env.BASE_URL}images/login-bg.png)`
      }
    }
  },
  data () {
    return {
      loading: false,
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    login () {
      this.$refs.loginForm.validate(async valid => {
        if (!valid || this.loading) return
        this.loading = true
        try {
          const { data } = await http.post('/sys/login', {
            username: this.form.username,
            password: this.form.password
          })
          if (data.code === 0) {
            localStorage.setItem('token', data.data.token)
            localStorage.setItem('username', data.data.username || this.form.username)
            this.$message.success('登录成功')
            this.$router.push('/home')
          }
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background: #f35b44;
}

.login-page__backdrop {
  position: absolute;
  inset: 0;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.login-page__overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(120deg, rgba(109, 34, 154, 0.45), rgba(255, 111, 74, 0.18) 45%, rgba(22, 157, 255, 0.32)),
    rgba(16, 22, 45, 0.18);
  backdrop-filter: blur(2px);
}

.login-page__glow {
  position: absolute;
  border-radius: 999px;
  filter: blur(12px);
  opacity: 0.65;
}

.login-page__glow--left {
  left: -8%;
  bottom: -10%;
  width: 340px;
  height: 340px;
  background: rgba(255, 214, 93, 0.38);
}

.login-page__glow--right {
  top: -8%;
  right: -4%;
  width: 300px;
  height: 300px;
  background: rgba(66, 203, 255, 0.3);
}

.login-page__content {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 48px;
  padding: 56px 7vw;
}

.login-page__intro {
  max-width: 540px;
  color: #ffffff;
  text-shadow: 0 8px 28px rgba(66, 20, 20, 0.28);
}

.login-page__eyebrow {
  margin: 0 0 16px;
  font-size: 13px;
  letter-spacing: 0.3em;
  opacity: 0.84;
}

.login-page__intro h1 {
  margin: 0 0 18px;
  font-size: 48px;
  line-height: 1.15;
  font-weight: 700;
}

.login-page__desc {
  margin: 0;
  font-size: 16px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.92);
}

.login-panel {
  width: 420px;
  max-width: 100%;
  padding: 34px 30px 28px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 28px 70px rgba(88, 39, 39, 0.22);
  backdrop-filter: blur(10px);
}

.login-panel__header h2 {
  margin: 0;
  color: #1f2a44;
  font-size: 28px;
}

.login-panel__header p {
  margin: 10px 0 0;
  color: #7f8aa3;
  font-size: 14px;
}

.login-form {
  margin-top: 28px;
}

.login-form ::v-deep .el-input__inner {
  height: 46px;
  border-radius: 10px;
  border-color: #f0d2d7;
  background: #fff8fa;
}

.login-form ::v-deep .el-input__prefix {
  color: #d16c7c;
}

.login-form__submit {
  width: 100%;
  height: 46px;
  margin-top: 6px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #ff6a54, #ffb347);
  box-shadow: 0 16px 30px rgba(255, 112, 84, 0.28);
}

.login-form__submit:hover,
.login-form__submit:focus {
  background: linear-gradient(135deg, #f35b44, #ffa235);
}

@media (max-width: 980px) {
  .login-page__content {
    justify-content: center;
    padding: 40px 20px;
  }

  .login-page__intro {
    display: none;
  }

  .login-panel {
    width: 100%;
    max-width: 420px;
  }
}
</style>
